import type { NativeStoreUpdates } from '@liscio/common';

type NativeMode = 'native-uat' | 'native-production';

// Activate each native scheme only after its own store build and link are verified.
const destinations: Record<NativeMode, NativeStoreUpdates> = {
  'native-uat': {},
  'native-production': {},
};

export function selectNativeStoreUpdates(
  mode: string,
  updatesByMode: Record<NativeMode, NativeStoreUpdates> = destinations
): NativeStoreUpdates {
  return mode === 'native-uat' || mode === 'native-production'
    ? updatesByMode[mode]
    : {};
}
